import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import T from 'i18n-react';

import { RefreshIcon } from '@motorway/motorway-storybook-cra';
import { Button } from '@motorway/mw-highway-code';

import Texts from 'Components/texts.json';

import styles from './VehicleListRefreshButton.module.scss';

T.setTexts(Texts);

interface VehicleListRefreshButtonProps {
	isEnabled?: boolean;
	isStickyHeaderVisible?: boolean;
	onClick: () => void;
	text: string;
}

const VehicleListRefreshButton: React.FC<VehicleListRefreshButtonProps> = ({
	isEnabled = false,
	isStickyHeaderVisible = false,
	onClick,
	text = '',
}) => {
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		setIsLoaded(true);
	}, []);

	return (
		<div
			className={cx(styles.vehicleListRefreshButton, {
				[styles.vehicleListRefreshButtonIsEnabled]: isEnabled,
				[styles.vehicleListRefreshButtonIsStickyHeaderVisible]: isStickyHeaderVisible,
				[styles.vehicleListRefreshButtonIsLoaded]: isLoaded,
			})}
		>
			<div className={styles.stickyPlaceholder}>
				<div className={styles.pillButtonContainer}>
					<Button icon={RefreshIcon} label={text} onClick={onClick} />
				</div>
			</div>
		</div>
	);
};

export default VehicleListRefreshButton;
